import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { GeneralTable } from '../../../shared/Table/GeneralTable';
import useLiveOrders from '../../../../hooks/liveOrders/useLiveOrders';
import { LIVE_ORDERS_HEAD_CELLS } from '../../../../utils/constans/tableHeads/liveOrdersTableHead';
import {
    LiveOrdersData,
    LiveOrdersHeadCellContent,
} from '../../../../models/LiveOrders';
import { LiveOrdersTableRow } from '../../../liveOrders/LiveOrdersTableRow';
import { Box } from '@mui/material';
import { TableLoadingLayout } from '../../../layouts/LoadingLayouts/TableLoadingLayout';

export const LiveOrders = () => {
    const { t } = useTranslation('liveOrders');
    const { orders, isLoading, isError, forceRefresh } = useLiveOrders();

    const tableHeadSettings = {
        translateNs: 'liveOrders',
        translatePrefix: 'LIVE_ORDERS.TABLE_HEAD',
        selectable: false,
        headContent: LIVE_ORDERS_HEAD_CELLS,
    };

    const tableToolbarSettings = {
        translateNs: 'liveOrders',
        translatePrefix: 'LIVE_ORDERS.TABLE_TOOLBAR',
    };

    const filterTerm = (search) => {
        return orders.filter((elem) => {
            return elem.orderID.includes(search);
        });
    };

    // const forceRefresh = () => {};

    return (
        <>
            <>
                <PageTitle>{t('LIVE_ORDERS.PAGE_TITLE')}</PageTitle>
                {isError && <Box>{t('LOADING_ERROR')}</Box>}
                {isLoading && <TableLoadingLayout />}
                {!isLoading && orders && (
                    <GeneralTable<LiveOrdersData, LiveOrdersHeadCellContent>
                        fullList={orders}
                        rowComponent={LiveOrdersTableRow}
                        filterTerm={filterTerm}
                        defaultOrderBy={'orderNo'}
                        defaultOrder={'desc'}
                        selectHandleId={'orderNo'}
                        tableHeadSettings={tableHeadSettings}
                        tableToolbarSettings={tableToolbarSettings}
                        forceRefresh={forceRefresh}
                        isLoading={isLoading}
                    />
                )}
            </>
        </>
    );
};
